<template>
  <Toast
    :show="useAuthStore().snackbar"
    :on-close="
      () => {
        useAuthStore().$patch({
          snackbar: false,
        });
      }
    "
    :title="useAuthStore().messageSnack"
    :state="useAuthStore().snackStatus"
    :duration="useAuthStore().snackTimeout"
    position="top-right"
  >
  </Toast>
</template>
<script setup>
import { Toast } from "@idds/vue";
</script>
<style>
#ina-toast-container-top-right {
  z-index: 9999 !important;
}
</style>
